import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Row } from 'antd'
import Job from '../domain/flag-management/job-detail/job-detail.component'
import { HistoricalProvider } from '../refactory/modules/jobs/infrastructure/job-detail/historical.context'
import { FeaturesConfigurationProvider } from '../refactory/modules/jobs/infrastructure/job-detail/features-configuration.context'

const JobModal = (props) => {
  const { t } = useTranslation()

  return (
    props.visible && (
      <Modal
        title={t('home.jobModal.title')}
        visible={true}
        onCancel={props.handleModal}
        footer={false}
        className='job-modal'
      >
        <div className='job-modal-body jobs-container'>
          <Row>
            <HistoricalProvider>
              <FeaturesConfigurationProvider>
                <Job
                  onCancel={props.handleModal}
                  currentUser={props.currentUser}
                  featureFlags={props.featureFlags}
                  getJobsList={props.getJobsList}
                  setSelectedJob={props.setSelectedJob}
                  selectedJob={props.selectedJob}
                  jobsSearch
                />
              </FeaturesConfigurationProvider>
            </HistoricalProvider>
          </Row>
        </div>
      </Modal>
    )
  )
}

export default JobModal
